import React, { useRef } from 'react';
import { Input } from '@/components/ui/input';
import { SearchIcon } from 'lucide-react';

interface ProductsSearchBoxProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  placeholder?: string;
  'data-cy'?: string;
}

export function ProductsSearchBox({
  value,
  onChange,
  className = '',
  placeholder = 'Search products...',
  'data-cy': dataCy,
  ...props
}: ProductsSearchBoxProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  // Handle key navigation
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Escape') {
      inputRef.current?.blur();
    }
  };

  return (
    <div className="relative w-full">
      <div className="relative">
        <SearchIcon className="absolute left-2.5 top-2.5 size-4 text-muted-foreground" />
        <Input
          ref={inputRef}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          className={`h-9 pl-8 ${className}`}
          data-cy={dataCy}
          {...props}
        />
      </div>
    </div>
  );
}
